import moment from "moment"
import type { LessonContext } from "../../lesson/default-lesson-context"

export interface PlanbookLessonsContext {
  planbookId: string
  planbookTitle: string
  dateString: string
  formattedDateString: string
  editType?: LessonContext["editType"]
}

export default function defaultPlanbookLessonContext(planbook, payload): PlanbookLessonsContext {
  let formattedDate = moment(payload.dateString).format("ddd, MMM. D, YYYY")
  return {
    planbookId: planbook.id,
    planbookTitle: planbook.attributes.title,
    dateString: payload.dateString,
    formattedDateString: formattedDate,
  }
}
